import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'blossomEnabled';
const EVENT = 'blossomEnabledChanged';

const read = () => {
  if (typeof window === 'undefined') return true;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === null ? true : stored === 'true';
};

export function useBlossomEnabled() {
  const [enabled, setEnabled] = useState(read);

  useEffect(() => {
    const onChange = (e) => setEnabled(e.detail);
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setEnabled(read());
    };
    window.addEventListener(EVENT, onChange);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT, onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const toggle = useCallback(() => {
    setEnabled(prev => {
      const next = !prev;
      try { window.localStorage.setItem(STORAGE_KEY, String(next)); } catch (_) {}
      window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
      return next;
    });
  }, []);

  return [enabled, toggle];
}
